export default __webpack_public_path__ + "static/media/safety.bb1478d5.JPG";